import { Result } from "@praha/byethrow"
import { getInstallationId } from "~/lib/installation-id"
import { savePushSubscription } from "../server/push.functions"
import { createPushSubscriptionSynchronizer } from "./push-subscription-synchronizer"

const MARKER_KEY = "pushSubscriptionSaved"

const storage = {
  get: () => localStorage.getItem(MARKER_KEY) ?? undefined,
  set: (value: string) => localStorage.setItem(MARKER_KEY, value),
}

const save = async (subscription: PushSubscription) => {
  const keys = subscription.toJSON().keys
  const result = await savePushSubscription({
    data: {
      endpoint: subscription.endpoint,
      p256dh: keys?.p256dh ?? "",
      auth: keys?.auth ?? "",
      userAgent: navigator.userAgent,
    },
  })
  if (Result.isFailure(result)) throw result.error
}

const synchronize = createPushSubscriptionSynchronizer(save)

export const persistPushSubscription = async (subscription: PushSubscription) => {
  const installationId = await getInstallationId()
  return synchronize(subscription, installationId ?? undefined, storage)
}
